export const themeConst = ["Default"];
//export const themeConst = ["Default", "Dark"];
export const statusConstResolvedAndHold = ['Resolved', 'On Hold'];
export const statusConstResolvedAndHoldProblem = ['Resolved', 'Pending'];
export const slaTargets = ['Response', 'Resolution'];
export const slaElapsed = ['25', '50', '75', '90', '100'];
export const slaTaggedOptions = ['Parent Incident', 'Child Incident'];
export const closedCancelledStatuses = ['!Closed', '!Cancelled', '!New'];
export const closedCancelledStatusesWithNew = ['!Closed', '!Cancelled'];
export const statusesWiseChartStatus = ['day', 'week', 'month'];
export const monthwiseStatus = ['month'];
export const MTTRStatuses = ['Closed', 'Resolved'];
export const WorkLoadStatuses = ['In Progress', 'On Hold', 'Resolved'];
export const SLABreachOptions = ['Yes', 'No'];
export const closedCancelledStatusArr = ['Closed', 'Cancelled'];

export const colorsArray = ['#00B050', '#92D050', '#FFFF00', '#ED7D31', '#FF0000'];
export const cSatSequence = ['Five', 'Four', 'Three', 'Two', 'One'];
export const tempalateMenuOptions = ['Use Template', 'Clone Incident'];
export const IncidentTypeOption = ['Incident', 'Service Request'];
export const csvFileTypeOption = [
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
];
export const forgotpPasswordConfig = [
    {
        'optResetTime': 15,
        'sessionResetTime': 180,
    }
];

export const userSessionTimeOutConfig = [
    {
        'warningTime': 14,
        'signoutTime': 15,
    }
];


export const moduleNameConfig = [
    {
        'value': 'WQ',
        'displayValue': 'WebQ',
    },
    {
        'value': 'UM',
        'displayValue': 'User Management',
    }
];

export const sipStauses = [
    {
        'value': 'free',
        'displayValue': 'Free',
    },
    {
        'value': 'reserved',
        'displayValue': 'Reserved',
    }
];
export const activeStauses = [
    {
        'value': 'Yes',
        'displayValue': 'Yes',
    },
    {
        'value': 'No',
        'displayValue': 'No',
    }
];
export const trunkIds = [
    {
        'value': 'Mascot Dc',
        'displayValue': 'Mascot Dc',
    },
    {
        'value': 'Blacktown Dc',
        'displayValue': 'Blacktown Dc',
    }
];

export const HistoryDefaultCol = [
    'IP Address',
    'Record Date Time',
    'Status',
    'User Name',
];

export const StatusColorCode = {
    'success': 'green',
    'failed': 'red',
    'partial success': 'orange',
    'fail': 'red',
}

export const ExecutionHistoryDefaultCol = [
    'Record Id',
    'Pipeline Name',
    //'Executed At',
    'Status',
    // 'User Name',
    // 'pipelineExecutionStepDetails',
    // 'pipelineExecutionParameter'
];

export const scriptTypes = [
    'python',
    'json',
];

export const ExecutionDetailsHistoryDefaultCol = [
    // 'Step Record Id',
    'Step Name',
    'Status',
    'User Name',
    'Executed At',
    'Pipeline Execution ID',
    'Response',
    //'Project Id'
];

//test//
export const ExecutionHistoryViewDetailsDefaultCol = [
    'Status',
    'Response',
    'Step Name',
]
//test//

export const excludedCustomCols = [
    'pipelineExecutionStepDetails',
    'pipelineExecutionParameter',
    'Project Id',
    'Download URL'
];

export const SNMPPlayDefaultCol = [
    'Customer Name',
    'IP Address',
    'Vendor',
    'Host Name'
]
